var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 467,
    viewBox: "0 0 450 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M269.073 28.147s137.692 8.208 78.562 179.144c-45.83 132.487 84.598 101.387 31.597 189.757-53.002 88.371-328.065 70.063-351.946-121.309C-2.137 39.946 269.073 28.147 269.073 28.147Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E3E3E3",
    d: "M146.444 375.168C71.56 329.176 48.138 231.186 94.13 156.302c45.991-74.884 143.981-98.306 218.865-52.314 74.885 45.991 98.307 143.981 52.315 218.865-45.992 74.885-143.982 98.307-218.866 52.315Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape05);
export default __webpack_public_path__ + "static/media/shape05.96ce4b4bba64054903b50284dbf8dee9.svg";
export { ForwardRef as ReactComponent };